__turbopack_context__.v({
  "Streamdown": "qJS5ra_Streamdown",
  "compact": "qJS5ra_compact",
  "dark": "qJS5ra_dark",
  "prose": "qJS5ra_prose",
  "prose-sm": "qJS5ra_prose-sm",
});
